export default "__VITE_ASSET__40a87107__"